import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { FaIndianRupeeSign,FaSpinner } from "react-icons/fa6";
import PublHomeData from "./PublHomeData";
import { useSelector } from 'react-redux';
import './PubOrderBody.css'; // Ensure this file contains the necessary CSS

export default function PubOrderBody() {
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const phoneNo = useSelector(state => state.pubLogin.userPhone);
    const selectedDate = location.state?.selectedDate;

    useEffect(() => {
        const fetchData = async () => {
            try {
             
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/getUserData`, {
                    phoneNo: phoneNo,
                    selectedDate: selectedDate // No need for further formatting
                });
                setUserData(response.data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [phoneNo, selectedDate]);

    if (loading) return <div className="text-center">
    <div className="spinner-container">
        <FaSpinner className="spinner-border" />
    </div>
</div>;
    if (error) return <div className="text-center text-danger">Error: {error}</div>;

  
    const noSelectStyle = {
        userSelect: "none",
        WebkitUserSelect: "none",  /* Safari */
        MozUserSelect: "none",     /* Firefox */
        msUserSelect: "none",      /* Internet Explorer/Edge */
        OUserSelect: "none"
    };

    

    return (
        <div className="container">
            <h3 className='text-center mt-3 mb-5 display-4'>List of Ordered Products</h3>
            <div className="row justify-content-center">
                {userData.map((data, index) => {
                    const productDetails = PublHomeData.find(product => product.name === data.ProductName);
                    return (
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index} style={noSelectStyle}>
                            <div className="card h-200">
                                <img src={productDetails.img} className="card-img-top full-size-image" alt={productDetails.name} />
                                <div className="card-body">
                                    <h4 className="card-title">{productDetails.name}</h4>
                                    <h5 className="card-text">{productDetails.descrption}</h5>
                                    <h4 className="card-title">Weight: {data.ProductWeight}</h4>
                                    <h5 className="card-text">Price: <FaIndianRupeeSign /> {data.ProductPrice}</h5>
                                    <h5 className="card-text">Quantity: {data.ProductQuantity}</h5>
                                   
                                    <h5 className="card-text">Status: {data.Status}</h5>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
